import React, { Component } from 'react';
import './Contact.css';

class Contact extends Component {
  render() {

    // TODO: icons

    return (
      <div className='Contact'>

        <div className='spacer'></div>
        
        <p className='header'>Contact</p>

        <p className='paragraph'>For all enquiries, please email <a href="mailto:simmonsbeth01@gmail.com?">simmonsbeth01@gmail.com</a></p>

        <p className='paragraph'>Instagram: <a href="https://www.instagram.com/beth.knit/">@beth.knit</a></p>

        <p className='paragraph'>Twitter: <a href="https://twitter.com/beth_knit">@beth_knit</a></p>

        <p className='paragraph'>LinkedIn: <a href="https://www.linkedin.com/in/beth-simmons-56b905153/">Beth Simmons</a></p>

      </div>
    );
  }
}

export default Contact;
